import React from 'react';
import {
  Form, Input, Button, Row, Col,
} from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const KeyValueList = ({ fieldsConfig = [], fieldName }) => {
  const { t } = useTranslation();

  return (
    <Form.List name={fieldName}>
      {(groups, { add, remove }) => (
        <>
          {groups.map(({ key, name }) => (
            <div key={key} style={{ marginBottom: 24 }}>
              <Row gutter={16} align="middle">
                {fieldsConfig.map(({ name: fieldKeyName, displayNameKey }) => (
                  <Col span={8} key={fieldKeyName}>
                    <Form.Item
                      name={[name, fieldKeyName]}
                      label={t(
                        `TELEMATICS.ACCOUNT.CREATE.LABELS.${(displayNameKey || fieldKeyName).toUpperCase()}`,
                      )}
                      rules={[
                        {
                          required: true,
                          message: `${displayNameKey || fieldKeyName} is required`,
                        },
                      ]}
                    >
                      <Input placeholder={displayNameKey || fieldKeyName} />
                    </Form.Item>
                  </Col>
                ))}

                <Col span={8}>
                  <Form.Item
                    label=" "
                    colon={false}
                    style={{ marginBottom: 25 }}
                  >
                    <Button
                      type="primary"
                      danger
                      icon={<CloseOutlined />}
                      onClick={() => remove(name)}
                      block
                    >
                      {t('TELEMATICS.ACCOUNT.BUTTON_REMOVE')}
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </div>
          ))}

          <Form.Item>
            <Button type="dashed" onClick={() => add({})} block>
              {t('TELEMATICS.ACCOUNT.BUTTON_ADD')}
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};

KeyValueList.propTypes = {
  fieldsConfig: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      displayNameKey: PropTypes.string,
    }),
  ).isRequired,
  fieldName: PropTypes.string,
};

KeyValueList.defaultProps = {
  fieldName: 'key_value_list',
};

export default KeyValueList;
